import React, { useEffect, useState, useContext } from "react";
import { Container, Grid, Card, Button, Form, Avatar, Profile, Media, Comment, GalleryCard, Icon,Table } from "tabler-react";
import Select from "react-select";
import SiteWrapper from "../SiteWrapper.react";
import { Crud_Catalogos, Crud_error } from '../herramientas/Crud_Catalogos';
import { NotificationContainer, NotificationManager} from 'react-notifications';
import {password} from '../herramientas/Forms';
import { softphoneContext } from "../context/softphoneContext";


var currentUser= JSON.parse(sessionStorage.getItem("currentUser"));
//Del profile original:
var user= JSON.parse(sessionStorage.getItem("usuario"));


//Del profile original:
var temas= [{ value: 0, label: "Selecciona  un tema" }, { value: 1, label: "Defaul" }, { value: 2, label: "Oscuro" }];
var perfil= JSON.parse(sessionStorage.getItem("perfil"));
var currentTema= user ? JSON.parse( localStorage.getItem('skyonetema'+user.id) ): null;
const temaDark= "body { /* sk */ margin: 0; font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif; font-size: 0.9375rem; font-weight: 400; line-height: 1.5; color: #79826d; text-align: left; background-color: rgba(58, 66, 59, 0.993); } .modal-content { position: relative; display: -ms-flexbox; display: flex; -ms-flex-direction: column; flex-direction: column; width: 100%; pointer-events: auto; background-color: rgba(96, 109, 98, 0.932); /* sk */ background-clip: padding-box; border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 3px; outline: 0; }.blockquote-footer {display: block;font-size: 80%;color: #868e96;/* sk */}.table th,.text-wrap table th,.table td,.text-wrap table td {padding: 0.75rem;vertical-align: top;border-top: 1px solid #e2e6de3a; /* sk */}.table-success,.table-success > th,.table-success > td {background-color: #d2ecb8; /* sk */}.table-hover .table-success:hover {background-color: #c5e7a4; /* sk */}.table-hover .table-success:hover > td,.table-hover .table-success:hover > th {background-color: #c5e7a4; /* sk */}.valid-feedback {display: none;width: 100%;margin-top: 0.25rem;font-size: 87.5%;color: #5eba00; /* sk */}.btn-primary { /* sk */color: #fff;background-color: #638069;border-color: #6b806f;}.btn-primary:hover { /* sk */color: #fff;background-color: #465849;border-color: #638069;}.dropdown-item:hover,.dropdown-item:focus {color: #16181b;text-decoration: none;background-color: rgba(238, 247, 213, 0.514); /* sk */}.dropdown-item.active,.dropdown-item:active {color: #fff;text-decoration: none;background-color: rgba(107, 139, 114, 0.993); /* sk */}.dropdown-item.disabled,.dropdown-item:disabled {color: #868e96; /* sk */background-color: transparent;}.nav-tabs .nav-link.active,.nav-tabs .nav-item.show .nav-link { /* sk */color: #77887b;background-color: rgba(36, 48, 39, 0.979);border-color: #77887b #77887b #91a595;}.card-header {padding: 1.5rem 1.5rem;margin-bottom: 0;background-color: rgba(49, 66, 58, 0.836); /* sk */border-bottom: 1px solid rgba(0, 40, 100, 0.12);}.card {  position: relative;  display: -ms-flexbox;  display: flex;  -ms-flex-direction: column;  flex-direction: column;  min-width: 0;  word-wrap: break-word;  background-color: rgba(20, 23, 18, 0.949);  background-clip: border-box;  border: 1px solid rgba(0, 100, 33, 0.12);  border-radius: 3px;}.header {  padding-top: 0.75rem;  padding-bottom: 0.75rem;  background: rgba(22, 26, 23, 0.993);  border-bottom: 1px solid rgba(0, 40, 100, 0.12);}.footer {  background: rgba(22, 26, 23, 0.993);  border-top: 1px solid rgba(0, 40, 100, 0.12);  font-size: 0.875rem;  padding: 1.25rem 0;  color: #b9c0cf;}.form-control {  display: block;  width: 100%;  padding: 0.375rem 0.75rem;  font-size: 0.9375rem;  line-height: 1.6;  color: #495057;  background-color: rgba(50, 67, 59, 0.84);  background-clip: padding-box;  border: 1px solid rgba(0, 40, 100, 0.12);  border-radius: 3px;  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;}.css-yk16xz-control {    background-color: rgba(50, 67, 59, 0.84);}.form-control:disabled,.form-control[readonly] {  background-color: rgba(50, 67, 59, 0.84);  opacity: 1;}.custom-switch-indicator {  display: inline-block;  height: 1.25rem;  width: 2.25rem;  background: rgba(0, 0, 0, 0.45);  border-radius: 50px;  position: relative;  vertical-align: bottom;  border: 1px solid rgba(0, 40, 100, 0.95);  transition: 0.3s border-color, 0.3s background-color;}.dropdown-menu {  position: absolute;  top: 100%;  left: 0;  z-index: 1000;  display: none;  float: left;  min-width: 10rem;  padding: 0.5rem 0;  margin: 0.125rem 0 0;  font-size: 0.9375rem;  color: #495057;  text-align: left;  list-style: none;  background-color: rgba(0, 0, 0, 0.98);  background-clip: padding-box;  border: 1px solid rgba(0, 40, 100, 0.12);  border-radius: 3px;}";


const  ProfilePage =()=> {
  const softphone = useContext(softphoneContext);

  const [pass, setPass]= useState(false);
  const [qr, setQr]= useState(false);
  const [dosFAEnable, setDosFAEnable]= useState(false);
  const [qrImage, setQrImage]= useState({});
  const [tema, setTema]= useState({ value: 0, label: "Selecciona  un tema" });
  const [passwordObj, setPasswordObj]= useState({ oldPassword: "", newPassword: "", newPasswordC: "" });
  const [troncal, setTroncal] = useState({});

  //newPassword : "", newPasswordC : ""
  useEffect(() => {
    if(currentTema){
      if( currentTema.value){
        for(let item of temas){
          if( item.value === currentTema.value){
            setTema(item);
            break;
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if( softphone.getValues().grupo ){
      getfuntion("get", "", "", "softphone_configuracion/grupo/" + softphone.getValues().grupo, "softphonePlataforma");
    }    
  }, [softphone]);
 
  const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "personas" , stateVar = "personas" ) => {
    return Crud_Catalogos(metodo !== "post" && catalogo.includes("personas")? "personas":catalogo , "tracking", metodo, id, obj, "", stateVar  ).then((returnVal) => {
      /**
       * filtro de variables
       */
      switch (metodo) {
        case "get":
          if (stateVar === "qr") {
            let respObj= {};
            respObj= returnVal;
            if( respObj.status == 200 ){
              respObj.message= JSON.parse(respObj.message);
              //console.log(respObj);
            }
            setQrImage(respObj);
          }
          if( stateVar === "softphonePlataforma"){
            setTroncal(returnVal);
          }
          break;
        case "put":
          if (stateVar === "contrana") { 
              if(returnVal.status===200){
                NotificationManager.success(returnVal.message, "Modificación");
                setPass(false);
                setQr(true);
                setQrImage({});
                getfuntion("get", "", "",  "usuarios/qr", "qr");
              }else{
                NotificationManager.error(returnVal.message, "Modificación");
              }
          }
          if (stateVar === "mfa") {
            setDosFAEnable(false);
            if(returnVal){
              NotificationManager.success("Usuario actualizado", "Modificación");
              user= returnVal;
              sessionStorage.setItem("usuario", JSON.stringify(user));
              for( let i=0; i<currentUser.length; i++ ){
                currentUser[i].usuario= {...returnVal};
              }
              sessionStorage.setItem("currentUser", JSON.stringify(currentUser));
            }else{
              NotificationManager.error("Parace que ha ocurrido un error", "Modificación");
            }
          }
          break;
        default:
          break;
      }
    }).catch(err => { console.log(err) });
  }
  const habilitarBoton=()=> {console.log(passwordObj);
    if (!password(passwordObj.newPassword).length && passwordObj.newPassword===passwordObj.newPasswordC){
       return false;
    }
    return true;
}
  return (
    <SiteWrapper>
      <div className="my-3 my-md-5">
        <Container>
          <Grid.Row>
            <Grid.Col lg={4}>
              <Card>
                <Card.Body>
                  <Media>
                    <Avatar
                      size="xxl"
                      className="mr-5"
                      imageURL="./user/user.png"
                    />
                    <Media.BodySocial
                      name={user.persona.aPaterno+" "+ user.persona.aMaterno+" "+user.persona.nombre}
                      workTitle={ perfil.nombre }

                    />
                  </Media>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <ul className="list-group">
                    <li className="list-group-item disabled">
                      <i className="fa fa-envelope">
                        <span Nameclass="badge"> { user.persona.correo }</span>
                      </i>
                    </li>
                    <li className="list-group-item">
                      <i className="fa fa-address-book-o">
                        <span Nameclass="badge"> { user.persona.skyangel? "Interno": "Externo" } </span>
                      </i>
                    </li>
                    <li className="list-group-item">
                      <i className="fa fa-phone">
                        <span Nameclass="badge"> { user.persona.telefono } </span>
                      </i>
                    </li>
                  </ul>
                  <hr/>
                  <h4>Webphone</h4>
                  { softphone.getValues().id?
                    <ul className="list-group">
                      <li className="list-group-item disabled">
                        <i className="fa fa-group">
                          <span Nameclass="badge"> { troncal.caller_id? troncal.caller_id : "" }</span>
                        </i>
                      </li>
                      <li className="list-group-item">
                        <i className="fa fa-hashtag">
                          <span Nameclass="badge"> { softphone.getValues().extension } </span>
                        </i>
                      </li>
                      <li className="list-group-item">
                        <i className="fa fa-user">
                          <span Nameclass="badge"> { softphone.getValues().username } </span>
                        </i>
                      </li>
                      <li className="list-group-item">
                        <i className="fa fa-pause-circle">
                          <span Nameclass="badge"> { softphone.getValues().pausaEstatus ? softphone.getValues().pausaMotivo: "Disponible" } </span>
                        </i>
                      </li>
                    </ul>
                    : null
                  }
                </Card.Body>
              </Card>
            </Grid.Col>
            <Grid.Col lg={8}>
              <div className="row">
                <div className="col-12">
                  <Card>
                    <Card.Header>
                      Configuración
                      <Card.Options>
                        <Button target="_blank" size="sm" RootComponent="a" color="primary"
                                onClick= { () =>{
                                  switch(tema.value){
                                    case 1:{
                                      localStorage.setItem('skyonetema'+user.id, JSON.stringify({ value: 1, tema: '' }) );
                                      window.location.href= "/perfilusuario";
                                      break;
                                    }
                                    case 2:{
                                      localStorage.setItem('skyonetema'+user.id, JSON.stringify({ value: 2, tema: temaDark }) );
                                      window.location.href= "/perfilusuario";
                                      break;
                                    }
                                    default:
                                      break;
                                  }
                                }}
                                disabled={ !tema.value }
                                icon={"save"}
                        >
                        </Button>
                      </Card.Options>
                    </Card.Header>
                    <Card.Body>
                      <Form.Group label="Tema">
                        <Select
                          value={ tema }
                          onChange={(e)=> setTema(e)}
                          options={ temas }
                        />
                      </Form.Group>
                      {tema.value === 1
                      ? <GalleryCard.Image
                          src={ "images/temadefault.jpg" }
                        />
                      : tema.value === 2
                          ?<GalleryCard.Image
                            src={ "images/temadark.jpg" }
                          />
                          :null
                      }
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-12"><hr/></div>
                <div className="col-12">
                  { pass?
                    <Card>
                      <Card.Body>
                        <Grid.Row>
                          <Grid.Col md={4 } lg={4}>              
                        
                            <Form.Group label="Password Anterior">             
                              <Form.Input name="oldPassword" type="password"
                                onChange={(e)=>{
                                  setPasswordObj({ ...passwordObj, oldPassword: e.target.value });
                                }} />
                              </Form.Group>
                          </Grid.Col>
                    
                          <Grid.Col md={ 4 } lg={ 4 }>
                            <Form.Group label="Nuevo Password">
                              <Form.Input name="newPassword" type="password"
                                value={passwordObj.newPassword}
                                onChange={(e)=>{
                                  setPasswordObj({ ...passwordObj, newPassword: e.target.value });
                                }}
                              />
                              <div >{password(passwordObj.newPassword)}</div>
                            </Form.Group>
                          </Grid.Col>          
                          <Grid.Col md={4} lg={4}>
                              <Form.Group label="Confirmar Password">
                                <Form.Input name="newPasswordC" type="password" 
                                  onChange={(e)=>{
                                    setPasswordObj({ ...passwordObj, newPasswordC: e.target.value });
                                  }}
                                />
                                <div>{passwordObj.newPasswordC && passwordObj.newPasswordC.length? passwordObj.newPasswordC === passwordObj.newPassword? "" : "Las contraseñas no son iguales" : ""}</div>
                              </Form.Group>
                          </Grid.Col>
                          <Table.Col>
                                <Button target="_blank" size="sm" RootComponent="a" color="primary"
                                disabled= { habilitarBoton()}
                                onClick={() =>{
                                  getfuntion("put", passwordObj, "",  "usuarios/password_from_user", "contrana");
                                }}
                                >
                                <span className="badge"><Icon link={true} name="refresh-ccw" /></span>
                                </Button>
                                <Button target="_blank" size="sm" RootComponent="a" color="danger" onClick={()=> this.setState({ pass: false}) } className="ml-2">
                                <span className="badge"><Icon link={true} name="x" />Cancelar</span>
                                </Button>           
                          </Table.Col>
                        
                        </Grid.Row>
                      </Card.Body>
                    </Card>
                    :
                      <a onClick={()=>setPass(true)}
                        className="text-primary btn">
                        Cambiar contraseña
                      </a>
                  }
                </div>
                <div className="col-12"><hr/></div>
                <div className="col-12">
                  { qr?
                    <div className="card">
                      <div className="card-header">
                        CÓDIGO QR
                      </div>
                      <div className="card-body  text-center">
                        <h5 className="card-title">Escanea el codigo en tu aplicación 2FA</h5>
                        { qrImage.status && qrImage.status !== 200 ?
                          <p className="card-text alert alert-danger">{qrImage.message}</p>
                          : null
                        }
                        { qrImage.status && qrImage.status === 200 ?
                          <p className="card-text">
                            <img src={qrImage.message.qrCode} className="d-block mx-auto" style={{cursor: "not-allowed", "pointerEvents": "none"}} />
                            <p>
                              {qrImage.message.mfaCode}
                            </p>
                          </p>
                          : null
                        }
                        <a href="#" className="btn btn-success" onClick={()=> setQr(false)}>Listo</a>
                      </div>
                    </div>
                    : null}
                  { !user.isUsingMfa?
                      <div>
                        { dosFAEnable?
                          <div class="card">
                            <div class="card-header">
                              Autenticación de dos factores 
                            </div>
                            <div class="card-body">
                              <h5 class="card-title">La autenticación de dos factores o 2FA esta desactivada. ¿Quieres activarla?</h5>
                              <p className="card-text">
                                La autenticación de dos factores o 2FA, proveera una capa de seguridad adicional.
                                Por defaul cada vez que inicien secion se te enviara un codigo via correo electronico a la cuenta {user.persona.correo}
                              </p>
                              <a href="#" className="btn btn-success"
                                onClick={()=>{
                                  let usuarioTemp= {...user};
                                  usuarioTemp.isUsingMfa= true;
                                  getfuntion("put", usuarioTemp, "",  "usuarios", "mfa");
                                }}>
                                  Activar
                              </a>
                              <a href="#" className="btn btn-danger ml-2" onClick={()=>  setDosFAEnable(false)}>Cancelar</a>
                            </div>
                          </div>
                          :
                          <a
                            onClick={()=>{
                              setDosFAEnable(true);
                            }}
                            className="text-primary btn">
                            <i class="fa fa-key" style={{"font-size": "24px"}}> </i> {" "+"Activar autenticación de dos factores"}
                          </a>
                        }   
                      </div>
                      : null
                  }
                  {/*
                    (!qr
                      ?<a
                          onClick={()=>{
                            setQr(true);
                            setQrImage({});
                            getfuntion("get", "", "",  "usuarios/qr", "qr");
                          }}
                          className="text-primary btn">
                            <p>La autenticación de dos factores o 2FA esta desactivada.</p>
                          <i class="fa fa-qrcode" style={{"font-size": "24px"}}> </i> {" "+"Ver Qr"}
                        </a>:null)
                  */}
                </div>
              </div>
            </Grid.Col>
          </Grid.Row>
        </Container>
      </div>
    </SiteWrapper>
  );
}

export default ProfilePage

